import * as NetflixAccountManagementActions from './../actions/netflix-account-management.actions';

import {
  NetflixWebTokenResource,
  TechnicalError,
} from '@dch/products-business-logic';

export interface NetflixAccountManagementState {
  token: NetflixWebTokenResource;
  isPending: boolean;
  error: TechnicalError;
}

export const initialState: NetflixAccountManagementState = {
  token: null,
  isPending: false,
  error: null,
};

export function reducer(
  state: NetflixAccountManagementState = initialState,
  action: NetflixAccountManagementActions.Actions,
): NetflixAccountManagementState {
  switch (action.type) {
    case NetflixAccountManagementActions.GET_NETFLIX_WEB_TOKEN:
      return {
        ...state,
        isPending: true,
        error: null,
      };
    case NetflixAccountManagementActions.GET_NETFLIX_WEB_TOKEN_SUCCESS:
      return {
        ...state,
        token: action.payload,
        isPending: false,
        error: null,
      };
    case NetflixAccountManagementActions.GET_NETFLIX_WEB_TOKEN_FAILED:
      return {
        ...state,
        token: null,
        error: action.payload,
        isPending: false,
      };
    default:
      return state;
  }
}

export const getNetflixToken = (state: NetflixAccountManagementState) =>
  state.token;
export const getTechnicalError = (state: NetflixAccountManagementState) =>
  state.error;
export const getPending = (state: NetflixAccountManagementState) =>
  state.isPending;
